import { window } from "global";
import { useMemo } from "react";
import { ApolloProvider, ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { initApolloClient } from "@ugg/shared/api/graphql/apollo-init";
import { useSupabaseAuth } from "@ugg/shared/components/auth/SupabaseAuthProvider";

interface ApolloContainerProps {
  ssrClient?: ApolloClient<NormalizedCacheObject>;
  children: React.ReactNode;
}

const customHeaders = {
  "x-app-type": "web" as const,
  "x-app-version":
    process.env.UGG_PUBLIC_BUILD_TYPE === "dugg" || process.env.NODE_ENV !== "production" ? "dev" : process.env.COMMIT_HASH,
};

export default function ApolloContainer({ ssrClient, children }: ApolloContainerProps) {
  const { client: supabase } = useSupabaseAuth();

  const client = useMemo(() => {
    if (ssrClient) {
      return ssrClient;
    }

    return initApolloClient("", window?.__APOLLO_STATE__, {
      customHeaders,
      getAuthHeader: async () => {
        const { data } = await supabase.auth.getSession();
        return data.session ? `Supabase ${data.session.access_token}` : null;
      },
    });
  }, [ssrClient, supabase]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
